<template>
  <v-container fluid class="pa-0">
    <v-card :loading="true" v-if="machine == null">
      <v-card-title>{{ $t("text.loading") }}</v-card-title>
    </v-card>
    <v-card v-else :loading="loading" flat>
      <v-row no-gutters>
        <v-col cols="12">
          <v-list v-if="documentList.length" density="compact" class="py-0 manuals-panel-list">
            <template v-for="(item, idx) in documentList" :key="item.Id">
              <v-divider v-if="idx > 0" />
              <v-list-item :title="item.Name" lines="one" class="manuals-panel-list__item" @click="showItem(item)">
                <template #prepend>
                  <v-icon :icon="getDocumentTypeIcon(item.DocumentType_Id)" />
                </template>
                <template #append>
                  <v-icon size="small" class="text-medium-emphasis" icon="mdi-open-in-new" />
                </template>
              </v-list-item>
            </template>
          </v-list>
          <v-card-text v-else-if="!loading" class="text-medium-emphasis">
            {{ $t("text.none_available") }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import http from "@/api/client";

export default {
  name: "CustomerMachineManualsPanel",

  props: {
    machine: { type: Object, default: null },
  },

  data() {
    return {
      documents: null,
      loading: false,
    };
  },

  computed: {
    documentList() {
      return Array.isArray(this.documents) ? this.documents : [];
    },
  },

  mounted() {
    if (this.machine) this.updateManuals(this.machine);
    else this.$emit("updateMachine");
  },

  methods: {
    showItem(item) {
      if (!item?.LinkUrl) return;
      window.open(item.LinkUrl, "_blank", "noopener,noreferrer");
    },

    getDocumentTypeIcon(documentTypeId) {
      const id = Number(documentTypeId);
      switch (id) {
        case 1:
          return "mdi-file-pdf-box";
        default:
          return "mdi-file-document-outline";
      }
    },

    updateManuals(machine) {
      if (!machine) {
        this.documents = null;
        return;
      }
      this.loading = true;
      http()
        .get("api2/customer/documents/manuals/" + machine.Id)
        .then((response) => {
          this.documents = response.data;
        })
        .catch(() => {
          this.documents = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    machine(val) {
      this.updateManuals(val);
    },
  },
};
</script>

<style scoped>
.manuals-panel-list__item {
  cursor: pointer;
}
</style>
